// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__1JVNx"};